import React from 'react';

import { COLORS } from '@/constants';
import { type IconName, iconNames } from '@/components/icons';

import { StyledIcon, Wrapper, StyledWarningIcon } from './styles';

type IconWithBackgroundProps = Record<string, unknown> & {
  backgroundColor: string;
  className?: string;
  iconName: IconName;
};

type WrappedIconWithBackgroundProps = Record<string, unknown> & {
  className?: string;
};

const IconWithBackground = ({ iconName, backgroundColor, className = '', ...props }: IconWithBackgroundProps) => {
  return (
    <Wrapper {...{ backgroundColor, className }}>
      <StyledIcon {...{ name: iconName }} {...props} />
    </Wrapper>
  );
};

export const iconsWithBackgrounds = {
  GreenTick: ({ className, ...props }: WrappedIconWithBackgroundProps) => (
    <IconWithBackground
      {...{
        iconName: iconNames.tick,
        backgroundColor: COLORS.SUCCESS_GREEN_NINE,
        'aria-label': 'Success',
        className,
        ...props,
      }}
    />
  ),
  BlueTick: ({ className, ...props }: WrappedIconWithBackgroundProps) => (
    <IconWithBackground
      {...{
        iconName: iconNames.tick,
        backgroundColor: COLORS.BRAND_NAVY_EIGHT,
        'aria-label': 'Safer Pick',
        className,
        ...props,
      }}
    />
  ),
  RedCross: ({ className, ...props }: WrappedIconWithBackgroundProps) => (
    <IconWithBackground
      {...{
        iconName: iconNames.cross,
        backgroundColor: COLORS.DANGER_RED_EIGHT,
        className,
        ...props,
      }}
    />
  ),
  GreyQuestionMark: ({ className, ...props }: WrappedIconWithBackgroundProps) => (
    <IconWithBackground
      {...{
        iconName: iconNames.questionMark,
        backgroundColor: COLORS.GREY_FOUR,
        className,
        ...props,
      }}
    />
  ),
  YellowQuestionMark: ({ className, ...props }: WrappedIconWithBackgroundProps) => (
    <IconWithBackground
      {...{
        iconName: iconNames.questionMark,
        backgroundColor: COLORS.GREY_FOUR,
        className,
        ...props,
      }}
    />
  ),
  GreyPlus: ({ className, ...props }: WrappedIconWithBackgroundProps) => {
    return (
      <IconWithBackground
        {...{
          iconName: iconNames.plus,
          backgroundColor: COLORS.GREY_FOUR,
          className,
          ...props,
        }}
      />
    );
  },
  // Since the warning icon already has the background added to it, it can directly use the Icon component
  RedWarning: ({ className }: WrappedIconWithBackgroundProps) => (
    <StyledWarningIcon {...{ name: iconNames.warning, 'aria-label': 'red warning' }} className={className} />
  ),
};

export default IconWithBackground;
